export function returnSaleRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_RETURN_SALE_START":           
        case "FETCH_RETURN_SALE_START":           
        case "DELETE_RETURN_SALE_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_RETURN_SALE_FULFILLED":           
        case "FETCH_RETURN_SALE_FULFILLED":           
        case "DELETE_RETURN_SALE_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_RETURN_SALE_ERROR":
        case "FETCH_RETURN_SALE_ERROR":
        case "DELETE_RETURN_SALE_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}